import { render } from "./ParametersSection.vue?vue&type=template&id=68abfa51&scoped=true&ts=true"
import script from "./ParametersSection.vue?vue&type=script&lang=ts"
export * from "./ParametersSection.vue?vue&type=script&lang=ts"

import "./ParametersSection.vue?vue&type=style&index=0&id=68abfa51&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68abfa51"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QDialog,QCard,QCardSection,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
